// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"78":"safety-handbbok","490":"supplier-responsibility","537":"procurement-post","596":"404","693":"apply-procurement","887":"procurement"}[chunkId] + "-legacy." + {"78":"616452f7","490":"3f8337f6","537":"0a68d45b","596":"c1c5e36b","693":"90f96f02","887":"b2b84627"}[chunkId] + ".js";
};